import { Component } from "react";
import { connect } from "react-redux";
import SiteMonitoringStructureBloc from "../SiteMonitoringStructureBloc";
import { withStyles } from "@mui/styles";
import { compose } from "redux";
import { setExpandedLotId, createLot } from "../../../redux/siteMonitoring/lotActions";
import { siteMonitoringIsDisabled } from "../../../redux/siteMonitoring/siteMonitoringActions";

const styles = {
    root: {
        width: "100%",
        marginTop: "5px",
    },
};

class StructureTab extends Component {
    addLot() {
        this.props.createLot(this.props.siteMonitoring, this.props.activeUser);
    }

    handleChange = (blocId) => {
        let collapsing = blocId === this.props.expandedLotId;

        this.props.setExpandedLotId(collapsing ? null : blocId);
    };

    render() {
        let siteMonitoringDisabled = siteMonitoringIsDisabled(this.props.siteMonitoring, this.props.activeUser);

        const { classes } = this.props;

        if (!this.props.selectedTab) return null;

        let lotElements = [];
        this.props.lots.forEach((l) => {
            if (l.deleted) return;

            let lotIndex = l.id;

            lotElements.push(
                <SiteMonitoringStructureBloc
                    key={lotIndex}
                    id={"bloc-lot-" + lotIndex}
                    currentBlocId={l.id}
                    lot={l}
                    onClick={this.handleChange.bind(this)}
                    disabled={siteMonitoringDisabled}
                    validated={l.validated}
                />
            );
        });

        let creationIndex = -1;

        lotElements.push(
            <SiteMonitoringStructureBloc
                key={creationIndex}
                id={"lot-creation-" + creationIndex}
                addLot={this.addLot.bind(this)}
                disabled={siteMonitoringDisabled}
                creationBloc
            />
        );

        return <div className={classes.root}>{lotElements.map((be) => be)}</div>;
    }
}

const mapStateToProps = (state) => {
    return {
        siteMonitoring: state.siteMonitoring.currentSiteMonitoring,
        lots: state.siteMonitoring.lots,
        activeUser: state.activeUser,
        expandedLotId: state.siteMonitoring.expandedLotId,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setExpandedLotId: (lotId) => dispatch(setExpandedLotId(lotId)),
        createLot: (siteMonitoring, user) => dispatch(createLot(siteMonitoring, user)),
    };
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(StructureTab);
